import { FC, ReactNode } from 'react';

export type FormGridProps = {
  children: ReactNode;
  columns?: 2 | 3;
  className?: string;
};

/** A form grid that collapses to one column on phones. */
const FormGrid: FC<FormGridProps> = ({ children, columns = 2, className }) => (
  <div className={['ui-form-grid', 'ui-form-grid--' + columns, className].filter(Boolean).join(' ')}>{children}</div>
);

export default FormGrid;
